// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiTokenTdh } from '../models/ApiTokenTdh';
import { ApiTokenTdhRank } from '../models/ApiTokenTdhRank';
import { HttpFile } from '../http/http';

export class ApiConsolidatedTdh {
    'block'?: number;
    'date'?: Date;
    'consolidation_key'?: string;
    'consolidation_display'?: string;
    'wallets'?: Array<string>;
    'balance'?: number;
    'unique_memes'?: number;
    'memes_cards_sets'?: number;
    'tdh'?: number;
    'boost'?: number;
    'boosted_tdh'?: number;
    'boosted_tdh_rate'?: number;
    'tdh__raw'?: number;
    'tdh_rank'?: number;
    'tdh_rank_memes'?: number;
    'tdh_rank_gradients'?: number;
    'tdh_rank_nextgen'?: number;
    'genesis'?: number;
    'nakamoto'?: number;
    'boosted_memes_tdh'?: number;
    'memes_tdh'?: number;
    'memes_tdh__raw'?: number;
    'memes_balance'?: number;
    'memes'?: Array<ApiTokenTdh>;
    'memes_ranks'?: Array<ApiTokenTdhRank>;
    'gradients_balance'?: number;
    'boosted_gradients_tdh'?: number;
    'gradients_tdh'?: number;
    'gradients_tdh__raw'?: number;
    'gradients'?: Array<ApiTokenTdh>;
    'gradients_ranks'?: Array<ApiTokenTdhRank>;
    'nextgen_balance'?: number;
    'boosted_nextgen_tdh'?: number;
    'nextgen_tdh'?: number;
    'nextgen_tdh__raw'?: number;
    'nextgen'?: Array<ApiTokenTdh>;
    'nextgen_ranks'?: Array<ApiTokenTdhRank>;
    'boost_breakdown'?: any;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "block",
            "baseName": "block",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "date",
            "baseName": "date",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "consolidation_key",
            "baseName": "consolidation_key",
            "type": "string",
            "format": ""
        },
        {
            "name": "consolidation_display",
            "baseName": "consolidation_display",
            "type": "string",
            "format": ""
        },
        {
            "name": "wallets",
            "baseName": "wallets",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "balance",
            "baseName": "balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "unique_memes",
            "baseName": "unique_memes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memes_cards_sets",
            "baseName": "memes_cards_sets",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tdh",
            "baseName": "tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boost",
            "baseName": "boost",
            "type": "number",
            "format": "double"
        },
        {
            "name": "boosted_tdh",
            "baseName": "boosted_tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boosted_tdh_rate",
            "baseName": "boosted_tdh_rate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "tdh__raw",
            "baseName": "tdh__raw",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tdh_rank",
            "baseName": "tdh_rank",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tdh_rank_memes",
            "baseName": "tdh_rank_memes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tdh_rank_gradients",
            "baseName": "tdh_rank_gradients",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tdh_rank_nextgen",
            "baseName": "tdh_rank_nextgen",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "genesis",
            "baseName": "genesis",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "nakamoto",
            "baseName": "nakamoto",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boosted_memes_tdh",
            "baseName": "boosted_memes_tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memes_tdh",
            "baseName": "memes_tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memes_tdh__raw",
            "baseName": "memes_tdh__raw",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memes_balance",
            "baseName": "memes_balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memes",
            "baseName": "memes",
            "type": "Array<ApiTokenTdh>",
            "format": ""
        },
        {
            "name": "memes_ranks",
            "baseName": "memes_ranks",
            "type": "Array<ApiTokenTdhRank>",
            "format": ""
        },
        {
            "name": "gradients_balance",
            "baseName": "gradients_balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boosted_gradients_tdh",
            "baseName": "boosted_gradients_tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "gradients_tdh",
            "baseName": "gradients_tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "gradients_tdh__raw",
            "baseName": "gradients_tdh__raw",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "gradients",
            "baseName": "gradients",
            "type": "Array<ApiTokenTdh>",
            "format": ""
        },
        {
            "name": "gradients_ranks",
            "baseName": "gradients_ranks",
            "type": "Array<ApiTokenTdhRank>",
            "format": ""
        },
        {
            "name": "nextgen_balance",
            "baseName": "nextgen_balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boosted_nextgen_tdh",
            "baseName": "boosted_nextgen_tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "nextgen_tdh",
            "baseName": "nextgen_tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "nextgen_tdh__raw",
            "baseName": "nextgen_tdh__raw",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "nextgen",
            "baseName": "nextgen",
            "type": "Array<ApiTokenTdh>",
            "format": ""
        },
        {
            "name": "nextgen_ranks",
            "baseName": "nextgen_ranks",
            "type": "Array<ApiTokenTdhRank>",
            "format": ""
        },
        {
            "name": "boost_breakdown",
            "baseName": "boost_breakdown",
            "type": "any",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiConsolidatedTdh.attributeTypeMap;
    }

    public constructor() {
    }
}
